import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
interface ProtectedRouteProps {
  children: React.ReactNode;
}
export function ProtectedRoute({
  children
}: ProtectedRouteProps) {
  const {
    user,
    loading
  } = useAuth();
  const location = useLocation();
  // Show loading state while checking authentication
  if (loading) {
    return <div className="flex items-center justify-center min-h-screen bg-[#f8f6f2]" data-id="element-1654">
        <div className="text-center" data-id="element-1655">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4" data-id="element-1656"></div>
          <p className="text-gray-600" data-id="element-1657">Loading...</p>
        </div>
      </div>;
  }
  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-1658" />;
  }
  return <>{children}</>;
}